import script from "./SectionTemplateModalRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionTemplateModalRow.vue?vue&type=script&setup=true&lang=ts"

import "./SectionTemplateModalRow.vue?vue&type=style&index=0&id=a8d98b6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8d98b6c"]])

export default __exports__